module.exports = __webpack_public_path__ + "static/img/loginrnd1.d4b3557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/loginrnd1.png
// module id = 351
// module chunks = 0